import JoditEditor from 'jodit-react';
import { CONSTANTS } from '../../constants';

interface WysiwygEditorProps {
  initialValue?: string
  onUpdateContent?: (content: string) => void
  placeholder?: string
  allowUrls?: boolean
}

const WysiwygEditor = (props: WysiwygEditorProps) => {
  const joditConfig = {
    readonly: false,
    placeholder: props.placeholder ?? 'Your content here...',
    saveSelectionOnBlur: false,
    cleanHTML: {
      allowTags: CONSTANTS.JODIT.ALLOWED_TAGS
    },
    style: {
      textAlign: 'left',
      wordBreak: 'break-word',
      overflowWrap: 'break-word',
      overflow: 'auto',
      overflowY: 'auto',
      lineHeight: '1.5',  // Fixed line height to prevent spacing changes
    },
    uploader: {
      url: 'none'
    },
    removeButtons: ['source', 'about', 'video', 'file', 'image', 'print', 'copyformat'],
    askBeforePasteHTML: false,
    askBeforePasteFromWord: false,
    enter: 'p' as const,
    enterBlock: 'p' as const,
    height: 400,
    minHeight: 400,
    maxHeight: 400,
    autoHeight: false,
    // Prevent auto-formatting that causes line spacing issues
    disablePlugins: ['resizer'],
  };

  return (
    <JoditEditor
      value={props.initialValue ?? ''}
      onBlur={props.onUpdateContent}  // Only update on blur - no onChange handler
      config={joditConfig}
    />
  );
}

export default WysiwygEditor;